import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const PopupBodyWrapper = styled('div')`
	padding: 15px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
	text-align: center;
`;

export { PopupBodyWrapper };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/LockedEditorPopup/styles.ts